import { RealtimeModes as modes } from "mobility-toolbox-js/api";
import PropTypes from "prop-types";
import qs from "query-string";
import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { TRACK_EVENT_CATEGORY_MAP } from "../../constants";
import { setMode, setVisibleStations, trackEvent } from "../../model/actions";
import {
  SwitcherSchematic as SchematicImg,
  SwitcherTopo as TopoImg,
} from "../icons";

import Button from "./Button";

const confs = {
  [modes.SCHEMATIC]: {
    img: <TopoImg />,
    nextMode: modes.TOPOGRAPHIC,
    title: "Topographische Sicht",
  },
  [modes.TOPOGRAPHIC]: {
    img: <SchematicImg />,
    nextMode: modes.SCHEMATIC,
    title: "Schematische Sicht",
  },
};

function ToggleButton() {
  const mode = useSelector((state) => state.mode);
  const map = useSelector((state) => state.map);
  const stationsLayer = useSelector((state) => state.stationsLayer);
  const dispatch = useDispatch();

  if (!mode) {
    return null;
  }

  const { img, nextMode, title } = confs[mode];

  return (
    <Button
      className="map-control"
      onClick={() => {
        const newVisibleStations = stationsLayer
          .getSource()
          .getFeaturesInExtent(map.getView().calculateExtent());
        // Set currently visible stations to find a correct extent after mode change.
        dispatch(setVisibleStations(newVisibleStations));
        dispatch(setMode(nextMode));
        dispatch(
          trackEvent(TRACK_EVENT_CATEGORY_MAP, "setBaselayer", nextMode),
        );
      }}
      tabIndex={-1}
      title={title}
    >
      {img}
    </Button>
  );
}
export default memo(ToggleButton);
